const ShowCardOptions = {
  ALL_CARDS: "all",
  SELECTED_CARDS: "selected"
};

ShowCardOptions.ALL = Object.values(ShowCardOptions);

export default ShowCardOptions;
